import {DocumentAmendment} from "common/flowmaster/types/amendment";

export function generateChainedTexts(
  texts: string[],
  firstBeforeText: string,
  lastAfterText: string,
): Array<{deleted_text: string; after_text: string; before_text: string}> {
  return texts.map((deleted_text, idx) => {
    const before_text = idx === 0 ? firstBeforeText : texts[idx - 1];
    const after_text =
      idx === texts.length - 1 ? lastAfterText : texts[idx + 1];

    return {
      deleted_text,
      before_text,
      after_text,
    };
  });
}

export function generateMultiLineDeleteAmendment(
  amendment: DocumentAmendment,
): DocumentAmendment {
  if (!amendment.deleted_text.includes("\n")) {
    return amendment;
  }

  const deletedText = amendment.deleted_text;
  const splitTexts = deletedText.split("\n").filter(line => line.length > 0);

  const clauseNumberRegex = /[A-Za-z0-9]+\.|\([A-Za-z0-9]+\)/;

  // Remove the last element if it is the start of the next heading. Word will handle renaming this.
  const filteredSplitTexts = splitTexts[splitTexts.length - 1].match(
    clauseNumberRegex,
  )
    ? splitTexts.slice(0, splitTexts.length - 1)
    : splitTexts;

  const subAmendments = generateChainedTexts(
    filteredSplitTexts,
    amendment.before_text,
    amendment.after_text,
  ).map(amendmentTexts => ({
    ...amendment,
    ...amendmentTexts,
  }));

  return {
    ...amendment,
    subAmendments,
  };
}
